__turbopack_context__.v({
  "description": "CreateWalletTitle-module__bcnJtG__description",
  "root": "CreateWalletTitle-module__bcnJtG__root",
  "title": "CreateWalletTitle-module__bcnJtG__title",
});
